import { createModel, RematchDispatch } from '@rematch/core';
import { produce } from 'immer';

import { storeName as layoutModelStore } from '../models/layout.model';
import baseEntity from './base.entity';
import { RootModel } from '../models';
import { ProjectCooperatorsItemTypes } from '../../types';
import { getCooperatorDetailByCode } from '../../services/project.service';

export const storeName = 'cooperatorEntity';

export const cooperatorEntity = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
    saves: produce((state, entities: ProjectCooperatorsItemTypes[]) => {
      (entities || []).forEach((entity) => {
        state.ids[entity.code] = entity;
      });
    }),
  },
  effects: (dispatch: RematchDispatch<typeof cooperatorEntity>) => ({
    async getCooperatorDetail(payload: string, state: RootModel) {
      const { locale } = state[layoutModelStore];
      const cooperator = await getCooperatorDetailByCode(payload, locale.apiLanguage);
      if (!cooperator) return null;
      this.saves([cooperator]);
      return cooperator;
    },
  }),
});

export default cooperatorEntity;
